'use strict';

function initRecaptcha(recaptchaConfigObj) {
    if (typeof grecaptcha === 'undefined') {
        return;
    }

    function recaptchaCreate(containerDef, callback) {
        const containerid = containerDef.containerId;
        // do not re-init recaptcha in the same container because
        // expiredCaptchaCallback will reset it after it has expired
        if (!$('#' + containerid).length || recaptchaConfigObj.captchaContainers[containerid] != undefined) {
            return;
        }

        recaptchaConfigObj.captchaContainers[containerid] = grecaptcha.render(containerid, {
            sitekey: SitePreferences.RECAPTCHA_SITEKEY,
            callback: callback.bind(this, containerDef),
            size: 'invisible',
            'expired-callback': function(response){
                expiredCaptchaCallback(response, recaptchaConfigObj);
            }
        });
    }

    recaptchaConfigObj.containerDefinitions.forEach(def => {
        recaptchaCreate(def, recaptchaCallback);
    });
}

function recaptchaCallback(def, response) {
    const containerDef = def;

    return new Promise(function (resolve, reject) { /* eslint-disable-line */
        containerDef.handler(response, containerDef);
        resolve();
    });
}

const expiredCaptchaCallback = function(recaptchaRes, recaptchaConfigObj) {
    recaptchaConfigObj.containerDefinitions.forEach(def => {
        grecaptcha.reset(recaptchaConfigObj.captchaContainers[def.containerId]);
    });
};

function defaultVerifyHandler(response, containerDef) {
    const recaptchaResponseElement = containerDef.$form.find('.js-recaptcha-response');

    if (!recaptchaResponseElement.length) {
        return;
    }

    recaptchaResponseElement.val(response);
    containerDef.$form.addClass(_constants.CHALLENGE_DONE_CLASS);
    containerDef.$form.find('[type=submit]').click();
}

function buildContainerDefinition($form, containerId, handlerFunction) {
    return {
        containerId: containerId,
        handler: handlerFunction,
        $form: $form
    };
}

const _constants = {
    CHALLENGE_DONE_CLASS: 'js-recaptchadone', // indicates if recaptcha challenge is resolved
    FORM_EXECUTE_RECAPTCHA_CLASS: 'js-executerecaptcha', // indicates that recaptcha challenge should be presented to customer
    RECAPTCHA_CONTAINER_ID_ATTR: 'recaptchacontainerid', // holds id of div containing recaptcha - only set for parent form element
    HIDE_RECAPTCHA_CLASS: 'js-donotuserecaptcha' // value set to indicate that recaptcha shouldn't be used yet on the page (until RateLimiter decides that on BE side)
};

const recaptchaConfig = {
    containerDefinitions: null,
    captchaContainers: null,
    CONSTANTS: _constants,

    buildContainerDefinition: buildContainerDefinition,
    defaultVerifyHandler: defaultVerifyHandler,
    defaultInitializationForFormById: defaultInitializationForFormById,
    executeForContainer: (containerId) => {
        if (!this.captchaContainers || !grecaptcha) {
            return;
        }

        const recaptchaContainer = this.captchaContainers[containerId];
        grecaptcha.reset(recaptchaContainer);
        grecaptcha.execute(recaptchaContainer);
    },
    removeChallengeDoneClass: (containerId) => {
        const $form = $('#' + containerId).parents('form');
        $form.removeClass(_constants.CHALLENGE_DONE_CLASS);
    },
    init: (newContainerDefinitions) => {
        const self = this;

        if (!self.containerDefinitions) {
            self.containerDefinitions = newContainerDefinitions || [];
        } else {
            newContainerDefinitions.forEach(function(newDef) {
                let addDefinition = true;
                self.containerDefinitions.forEach(function(existingDef) {
                    if (newDef.containerId == existingDef.containerId) {
                        addDefinition = false;
                    }
                });

                if (addDefinition) {
                    self.containerDefinitions.push(newDef);
                }
            });
        }

        if (!self.captchaContainers) {
            self.captchaContainers = {};
        }

        if (typeof grecaptcha !== 'undefined') {
            if (!(grecaptcha.render instanceof Function)) {
                $(document).on('recaptchaReady', function () { // recaptchaReady event is triggered once the recaptcha script is loaded
                    initRecaptcha(self);
                });
            } else {
                initRecaptcha(self);
            }
        }
    }
};

function defaultInitializationForFormById(formId) {
    const recaptchaContainerId = 'recaptcha-container';
    const recaptchaFormContainer = $('#' + recaptchaContainerId);

    if (recaptchaFormContainer && recaptchaFormContainer.length) {
        const $form = $('#' + formId);
        recaptchaConfig.init([buildContainerDefinition($form, recaptchaContainerId, defaultVerifyHandler)]);
        $form.addClass(_constants.FORM_EXECUTE_RECAPTCHA_CLASS);
        $form.data(_constants.RECAPTCHA_CONTAINER_ID_ATTR, recaptchaContainerId);
    }
}

module.exports = recaptchaConfig;
